export const BNPL_CONSTANTS = {
    // LENGTH FOR FIELDS
    FIELDS_LENGTH: {

        EMAIL: {
            MAX_LENGTH: 200,
            MIN_LENGTH: 10,
        },

        PHONE: {
            MAX_LENGTH: 15,
            MIN_LENGTH: 8,
        },

        PHONE_CODE: {
            MAX_LENGTH: 3,
        },

        NAME: {
            MAX_LENGTH: 50,
            MIN_LENGTH: 8,
        },

        LAST_NAME: {
            MAX_LENGTH: 50,
            MIN_LENGTH: 8,
        },

        DI: {
            MAX_LENGTH: 20,
            MIN_LENGTH: 6,
        },

        TYPE_DI: {
            MAX_LENGTH: 15,
        }
    }
}